
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule, FuseWidgetModule} from "../../../@fuse/components";
import {MatNativeDateModule, MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {SupplierOrderModule} from "../supplierOrder/supplierOrder.module";
import {TranslateModule} from "@ngx-translate/core";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatTabsModule} from "@angular/material/tabs";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatChipsModule} from "@angular/material/chips";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatTableModule} from "@angular/material/table";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {NoteComponent} from "./note.component";
import {NoteListSidebarComponent} from "./sidebars/list/list-sidebar.component";
import {NewNoteDialogComponent} from "./dialog/newNoteDialog.component";
import {NoteConfirmDialogComponent} from "./dialog/noteConfirmDialog.component";
import {NoteDeleteDialogComponent} from "./dialog/noteDeleteDialog.component";
import {ResponseDialogComponent} from "./dialog/responseDialog.component";

@NgModule({
    declarations: [
        NoteComponent,
        NoteListSidebarComponent,
        NewNoteDialogComponent,
        NoteConfirmDialogComponent,
        NoteDeleteDialogComponent,
        ResponseDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        SupplierOrderModule,
        TranslateModule,
        MatAutocompleteModule,
        BrowserModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatExpansionModule,
        FuseWidgetModule,
        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTableModule,
        MatTabsModule,

        NgxChartsModule,
    ],
    providers: [

    ],
    bootstrap: [
        NoteComponent,
        NewNoteDialogComponent,
        NoteConfirmDialogComponent,
        NoteDeleteDialogComponent,
        ResponseDialogComponent,
    ],
    schemas: [

    ]
})
export class NoteModule { }
